import { LeadType, UserType } from '../common/enums';

export enum UserNoteType {
  Student = UserType.Student,
  Staff = UserType.Staff,
  Enrolment = LeadType.Enrolment,
  Contact = LeadType.Contact,
}

const IS_USER_NOTE_TYPE = {
  [UserNoteType.Student]: true,
  [UserNoteType.Staff]: true,
  [UserNoteType.Enrolment]: true,
  [UserNoteType.Contact]: true,
} satisfies Record<UserNoteType, true>;

/**
 * Every kind of note. `Object.values(UserNoteType)` also returns the reverse mappings that a
 * compiler reading one file at a time emits for members copied from another enum.
 */
export const USER_NOTE_TYPES = Object.keys(IS_USER_NOTE_TYPE) as readonly UserNoteType[];

export enum UserNoteAssignee {
  Unassigned = 'UNASSIGNED',
}

export enum UserNoteCreator {
  Honeycode = 'HONEYCODE',
  CognitoWebsite = 'COGNITO_WEBSITE',
  CognitoAutomation = 'COGNITO_AUTOMATION',
}

export const UserNoteCreatorDisplayName: Record<UserNoteCreator, string> = {
  [UserNoteCreator.Honeycode]: 'Honeycode',
  [UserNoteCreator.CognitoWebsite]: 'Cognito Website',
  [UserNoteCreator.CognitoAutomation]: 'Cognito Automation',
};
